import axios from "axios";
import AxiosAPI from "./AxiosAPI";

export const getDashboardSetting = async () => {
  try {
    const response = await AxiosAPI.get("/dashboard/settings");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const handleAddDashboardSetting = async (data) => {

  try {
    const response = await AxiosAPI.post("/dashboard/setting", data, {
    });
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
};

export const updateDashboardSetting = async (key,data) => {

  try {
    const response = await AxiosAPI.put(`/dashboard/setting/${key}`, data, {
    });
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
};

export const getPincodeProductFunnel = async (stores) => {
  let storeids = [];
  stores.map((s) => {
    if (s.key !== "") {
      storeids.push(s.key);
    }
  });
  // console.log(storeids);
  // let result = await getPincodeProductDashboard(storeids);

  let result = await axios.post(
    "https://backend-197598313260.asia-south1.run.app/v1/reports/pincode/products/dashboard",
    {
      storeIds: storeids,
    },
    {
      headers: {
        "Content-Type": "application/json", // Explicitly set the content type
      },
    }
  );
  // console.log("WidgetPincodeProductDashboard result", result);
  let tmp = [];
  if (
    result &&
    result.data &&
    result.data.result &&
    result.data.result.length > 0
  ) {
    tmp = result.data.result;
  }
  return tmp;
};

export const getSalesPincode = async (selectedStores, customDate) => {
  try {
    const response = await AxiosAPI.get("/dashboard/sales/pincode", {
      params: {
        fromDate: customDate.fromDate,
        toDate: customDate.toDate,
        stores: JSON.stringify(
          selectedStores.map((store) => ({
            key: store.key,
            label: store.StoreName,
          }))
        ),
        cashRegister: "",
        transactionType: "",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getSalesForLast12Months = async (
  selectedStores,
  formattedFromDate,
  formattedToDate,
  interval
) => {
  try {
    const response = await AxiosAPI.get("/dashboard/sales-for-last12-months", {
      params: {
        fromDate: formattedFromDate,
        toDate: formattedToDate,
        // stores: JSON.stringify(selectedStores),
        stores: JSON.stringify(
          selectedStores.map((store) => ({
            key: store.key,
            label: store.StoreName,
          }))
        ),
        interval: interval,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getSalesDashboard = async (selectedStores, customDate) => {
  try {
    const response = await AxiosAPI.get("/dashboard/sales", {
      params: {
        fromDate: customDate.fromDate,
        toDate: customDate.toDate,
        stores: JSON.stringify(
          selectedStores?.map((store) => ({
            key: store.key,
            label: store.StoreName,
          }))
        ),
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getPurchaseDashboard = async (selectedStores, customDate) => {
  try {
    const response = await AxiosAPI.get("/dashboard/purchase", {
      params: {
        fromDate: customDate.fromDate,
        toDate: customDate.toDate,
        stores: JSON.stringify(
          selectedStores?.map((store) => ({
            key: store.key,
            label: store.StoreName,
          }))
        ),
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getProductWiseSales = async (selectedStores, customDate,size,sortBy) => {
  try {
    const response = await AxiosAPI.get("/dashboard/sales/product-wise", {
      params: {
        fromDate: customDate.fromDate,
        toDate: customDate.toDate,
        stores: JSON.stringify(
          selectedStores.map((store) => ({
            key: store.key,
            label: store.StoreName,
          }))
        ),
        size:size,sortBy:sortBy
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getCategoryWiseSales = async (selectedStores, customDate,size=5,sortBy="amount") => {
  try {
    const response = await AxiosAPI.get("/dashboard/sales/category-wise", {
      params: {
        fromDate: customDate.fromDate,
        toDate: customDate.toDate,
        stores: JSON.stringify(
          selectedStores.map((store) => ({
            key: store.key,
            label: store.StoreName,
          }))
        ),
          size:size,
      sortBy:sortBy // or "qty"
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getSubCategoryWiseSales = async (selectedStores, customDate,size=10,sortBy="amount") => {
  try {
    const response = await AxiosAPI.get("/dashboard/sales/subcategory-wise", {
      params: {
        fromDate: customDate.fromDate,
        toDate: customDate.toDate,
        stores: JSON.stringify(
          selectedStores.map((store) => ({
            key: store.key,
            label: store.StoreName,
          }))
        ),
        size:size,
      sortBy:sortBy,
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getBrandWiseSales = async (selectedStores, customDate,size = 10,sortBy = "amount",) => {
  try {
    const response = await AxiosAPI.get("/dashboard/brand-wise-sales", {
      params: {
        fromDate: customDate.fromDate,
        toDate: customDate.toDate,
        stores: JSON.stringify(
          selectedStores.map((store) => ({
            key: store.key,
            label: store.StoreName,
          }))
        ),
        size:size,
        sortBy:sortBy
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getProductTypeWiseSales = async (selectedStores, customDate) => {
  try {
    const response = await AxiosAPI.get("/dashboard/product-type-wise-sales", {
      params: {
        fromDate: customDate.fromDate,
        toDate: customDate.toDate,
        stores: JSON.stringify(
          selectedStores.map((store) => ({
            key: store.key,
            label: store.StoreName,
          }))
        ),
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getEmployeeWiseSales = async (selectedStores, customDate,size = 10,sortBy = "amount") => {
  try {
    const response = await AxiosAPI.get("/dashboard/employee-wise-sales", {
      params: {
        fromDate: customDate.fromDate,
        toDate: customDate.toDate,
        stores: JSON.stringify(
          selectedStores.map((store) => ({
            key: store.key,
            label: store.StoreName,
          }))
        ),
        size:size,
        sortBy:sortBy
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getTopProductType = async (selectedStores, customDate,type, size = 10, sortBy = "amount",) => {
  try {
    const response = await AxiosAPI.get("/dashboard/top-product-types", {
      params: {
        fromDate: customDate.fromDate,
        toDate: customDate.toDate,
        stores: JSON.stringify(
          selectedStores.map((store) => ({
            key: store.key,
            label: store.StoreName,
          }))
        ),
       type:type, size:size, sortBy:sortBy,
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getWalkinCustomer = async (selectedStores, customDate) => {
  try {
    const response = await AxiosAPI.get("/dashboard/walkin-customers", {
      params: {
        fromDate: customDate.fromDate,
        toDate: customDate.toDate,
        stores: JSON.stringify(
          selectedStores.map((store) => ({
            key: store.key,
            label: store.StoreName,
          }))
        ),
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getSalesCustomer = async (selectedStores, customDate) => {
  try {
    const response = await AxiosAPI.get("/dashboard/sales-customers", {
      params: {
        fromDate: customDate.fromDate,
        toDate: customDate.toDate,
        stores: JSON.stringify(
          selectedStores.map((store) => ({
            key: store.key,
            label: store.StoreName,
          }))
        ),
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getNewCustomer = async (
  selectedStores,
  customDate,
  customerIDs
) => {
  try {
    const response = await AxiosAPI.get("/dashboard/new-customers", {
      params: {
        fromDate: customDate.fromDate,
        toDate: customDate.toDate,
        customerIDs: customerIDs,
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getRepeatedCustomer = async (
  selectedStores,
  customDate,
  customerIDs
) => {
  try {
    const response = await AxiosAPI.get("/dashboard/repeated-customers", {
      params: {
        fromDate: customDate.fromDate,
        toDate: customDate.toDate,
        customerIDs: customerIDs,
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getDashboardHeader = async (selectedStores, fromDate,toDate) => {
  try {
    const response = await AxiosAPI.get("/dashboard/headers", {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        stores: JSON.stringify(
          selectedStores.map((store) => ({
            key: store.key,
            label: store.StoreName,
          }))
        ),
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getTotalPaymentReceived = async (selectedStores, fromDate,toDate) => {
  try {
    const response = await AxiosAPI.get("/dashboard/total-payment-recieved", {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        stores: JSON.stringify(
          selectedStores.map((store) => ({
            key: store.key,
            label: store.StoreName,
          }))
        ),
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getSpecificPaymentmodeSales = async (
  selectedStores,
  fromDate,
  toDate,
  paymentMode
) => {
  try {
    const response = await AxiosAPI.get(
      "/dashboard/specific-paymentmode-sales",
      {
        params: {
          fromDate: fromDate,
          toDate: toDate,
          stores: JSON.stringify(
            selectedStores.map((store) => ({
              key: store.key,
              label: store.StoreName,
            }))
          ),
          paymentMode: paymentMode,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getExpensesforSalesDashboard = async (
  selectedStores,
  fromDate,
  toDate
) => {
  console.log("fromdate",fromDate);
  console.log("todate",toDate);
  try {
    const response = await AxiosAPI.get("/dashboard/sales-expenses", {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        stores: JSON.stringify(
          selectedStores.map((store) => ({
            key: store.key,
            label: store.StoreName,
          }))
        ),
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getSalesBasedOnTransactionTypes = async (
  selectedStores,
  fromDate,
  toDate,
  transactionTypeIDs
) => {
  try {
    const response = await AxiosAPI.get(
      "/dashboard/sales-transactiontype-based",
      {
        params: {
          fromDate: fromDate,
          toDate: toDate,
          stores: JSON.stringify(
            selectedStores.map((store) => ({
              key: store.key,
              label: store.StoreName,
            }))
          ),
          transactionTypeIDs: transactionTypeIDs,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getPincodeDashboardHeader = async (
  selectedStores,
  customDate,
  cashRegister = "",
  transactionType = ""
) => {
  try {
    const response = await AxiosAPI.get("/dashboard/pincode/headers", {
      params: {
        fromDate: customDate.fromDate,
        toDate: customDate.toDate,
        stores: JSON.stringify(
          selectedStores.map((store) => ({
            key: store.key,
            label: store.StoreName,
          }))
        ),
        cashRegister: cashRegister,
        transactionType: transactionType,
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getPaymentModeTransactionTypeWiseSales = async (
  selectedStores,
  customDate,
  salesImpacted=""
) => {
  try {
    const response = await AxiosAPI.get(
      "/dashboard/sales/paymentmode/transactiontype",
      {
        params: {
          fromDate: customDate.fromDate,
          toDate: customDate.toDate,
          stores: JSON.stringify(
            selectedStores.map((store) => ({
              key: store.key,
              label: store.StoreName,
            }))
          ),
          salesImpacted: salesImpacted,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

//pincode top product api
export const getProductTransactionTypeWiseSales = async (
  selectedStores,
  customDate,
  size = 10,
  sortBy = "qty",
  transactionTypes = []
) => {
  try {
    const response = await AxiosAPI.get(
      "/dashboard/pincode/product/transaction-wise",
      {
        params: {
          fromDate: customDate.fromDate,
          toDate: customDate.toDate,
          stores: JSON.stringify(
            selectedStores.map((store) => ({
              key: store.key,
              label: store.StoreName,
            }))
          ),
          size: size,
          sortBy: sortBy,
          transactionTypes: transactionTypes,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getCategoryTransactionTypeWiseSales = async (
  selectedStores,
  customDate,
  size = 10,
  sortBy = "qty",
  transactionTypes = []
) => {
  try {
    const response = await AxiosAPI.get(
      "/dashboard/pincode/category/transaction-wise",
      {
        params: {
          fromDate: customDate.fromDate,
          toDate: customDate.toDate,
          stores: JSON.stringify(
            selectedStores.map((store) => ({
              key: store.key,
              label: store.StoreName,
            }))
          ),
          size: size,
          sortBy: sortBy,
          transactionTypes: transactionTypes,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const getBrandTransactionTypeWiseSales = async (
  selectedStores,
  customDate,
  size = 10,
  sortBy = "qty",
  transactionTypes = []
) => {
  try {
    const response = await AxiosAPI.get(
      "/dashboard/pincode/brand/transaction-wise",
      {
        params: {
          fromDate: customDate.fromDate,
          toDate: customDate.toDate,
          stores: JSON.stringify(
            selectedStores.map((store) => ({
              key: store.key,
              label: store.StoreName,
            }))
          ),
          size: size,
          sortBy: sortBy,
          transactionTypes: transactionTypes,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
